<template>
    <div class="live-banner flexstart">
        <div class="banner left">
            <el-carousel height="446px">
                <el-carousel-item v-for="(obj,i) in datalist" :key="i">
                    <div class="img-box" @click="detailClick(obj.livetype,obj.innerid)">
                        <img class="img" v-lazy="obj.newlogoaurl" :alt="obj.subject" >
                        <div class="adtitle fs-20 tc-write text-ellipse">{{obj.subject}}</div>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="right author-list">
            <div class="title flex-between">
                <span class="icon_anthor flex-start fs-20 blod">鲸视频</span>
                <span class="pointer fs-12 tc-grey" @click="handleMore">更多></span>
            </div>
            <div class="box flex-start pointer" v-for="(obj,i) in authorlist" :key="i" @click="handleClick(obj)">
                <div class="img-box">
                    <img class="img" v-lazy="obj.logourl" alt="">
                </div>
                <div class="text-box">
                    <div class="fs-14 tc-black text-ellipses subject">{{obj.subject}}</div>
                    <div class="fs-12 tc-grey text-ellipse description">{{obj.hostname}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import {mapActions} from 'vuex'
  import {getLiveToBannerByPC} from 'api/web-app'
  export default {
    name: 'live-banner',
    data() {
      return {
        param: {},
        datalist: [],
        authorlist: [],
        topicid: ''
      }
    },
    mounted() {
      this._getList()
    },
    methods: {
      handleMore() {
        this.$router.push({name: 'livingVideoList', query: {topicid: this.topicid}})
      },
      goto(obj) {
        window.open(obj.clickurl)
      },
      detailClick(type, id){
        if (type == 1) {
          // 视频直播
          let videoDataPc = this.$router.resolve({
            name: "VideoLiveing",
            query: {innerid:id}
          });
          window.open(videoDataPc.href, '_blank');
        } else {
          // 图文直播
          let routeDataPc = this.$router.resolve({
            name: "LiveingDetails",
            query: {innerid:id}
          });
          window.open(routeDataPc.href, '_blank');
        }
      },
      handleClick(obj) {
        this.setRefresh(true)
        this.$router.push({name: 'livingVideoView', query: {'kmcinnerid': obj.kmcinnerid}})
      },
      _getList() {
        this.setLoading(true)
        getLiveToBannerByPC({
          data: this.param,
          success: data => {
            this.setLoading(false)
            this.datalist = data.data.liveinfo
            this.authorlist = data.data.topicinfo
            this.topicid = data.data.topicid
          },
          error: data => {
            this.setLoading(false)
            this.$message.error(data.msg)
          }
        })
      },
      ...mapActions(['setLoading', 'setRefresh'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
  }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.live-banner {
    padding-top: 20px;
    width: 1200px;
    margin: auto;
    .banner{
        width: 792px;
        min-width: 792px;
        margin-right: 30px;
        .img-box{
            width: 792px;
            height: 446px;
            background: #1464C8;
            position: relative;
            overflow: hidden;
            .img{
                width: 100%;
                height:100%;
                border-radius: 4px;
            }
            .adtitle{
                height: 80px;
                left: 0;
                right:0;
                position: absolute;
                bottom: 0;
                padding: 20px 20px;
                box-sizing: border-box;
                background-image: linear-gradient(180deg, rgba(0,0,0,0.00) 0%, rgba(0,0,0,0.40) 57%, rgba(0,0,0,0.80) 100%);
                border-radius: 0 0 4px 4px;
            }
        }
        .el-carousel__indicators--horizontal{
            left:0;
            bottom: 5px;
            transform: translateX(20px)
        }
    }
    .author-list{
        height: 446px;
        flex-grow: 1;
        .title{
            margin-bottom: 10px;
            line-height: 28px;
        }
        .icon_anthor:before{
            width: 16px;
            height: 16px;
            margin-right: 10px;
        }
        .box{
            height: 98px;
            box-sizing: border-box;
            padding: 7px 10px;
            box-sizing: border-box;
            .subject{
                margin-bottom: 10px;
                word-wrap:break-word;
                word-break:break-all;
            }
            &:hover{
                box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
            }
        }
        .box+.box{
            margin-top: 7px;
        }
        .img-box{
            margin-right: 10px;
            width: 150px;
            min-width: 150px;
            height: 84px;
            border-radius: 4px;
            overflow: hidden;
            position: relative;
            &:before{
                content: '';
                display: inline-block;
                position: absolute;
                border-radius: 4px;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: rgba(0, 0, 0);
                opacity: 0;
                transition: all 0.3s;
            }
            &:after{
                content: '';
                display: inline-block;
                position: absolute;
                top: calc(50% - 12px);
                left: calc(50% - 12px);
                width: 24px;
                height: 24px;
                opacity: 0;
                background: url("~common/images/leveing/live-detail/player.png");
            }
            &:hover:before{
                opacity: 0.4;
            }
            &:hover:after{
                opacity: 1;
            }
            img{
                width: 100%;
                height: 100%;
                border-radius: 4px;
            }
        }
        .text-box{
            flex-grow: 1;
            width: 217px;
            height: 100%;
            .subject{
                line-height: 24px;
                margin-bottom: 4px;
            }
            .description{
                line-height: 20px;
            }
        }
    }

}
</style>